<template>
  <svg
    xmlns:xlink="http://www.w3.org/1999/xlink"
    class="pointer-events-none scatter-vect"
    xmlns="http://www.w3.org/2000/svg"
    :viewBox="isSmall ? viewBox : deskViewBox"
    :height="vectH"
  >
    <defs>
      <linearGradient id="scatter-grad" x1="-48.845%" x2="76.697%" y1="194.689%" y2="27.291%">
        <stop offset="0%" :stop-color="mainColor"/>
        <stop offset="100%" :stop-color="accent"/>
      </linearGradient>

      <path ref="mktgLarge" id="mktg-large-scatter"
            :d="isSmall ? mktgLargeScatterD : deskMktgLargeScatterD"/>
      <path ref="mktgSmall" id="mktg-small-scatter"
            :d="isSmall ? mktgSmallScatterD : deskMktgSmallScatterD "/>
      <path ref="itLarge" id="it-large-scatter"
            :d="isSmall ? itLargeScatterD : deskItLargeScatterD"/>
      <path ref="itSmall" id="it-small-scatter"
            :d="isSmall ? itSmallScatterD : deskItSmallScatterD"/>
      <path ref="largeLine" id="large-scatter-line"
            :d="isSmall ? largeScatterLineD : deskLargeScatterLineD"/>
      <path ref="smallLine" id="small-scatter-line"
            :d="isSmall? smallScatterLineD : deskSmallScatterLineD"/>
    </defs>

    <g :transform="isSmall ? 'translate(-20 ' + transY + ')' : 'translate(0 ' + transY + ')'">

      <mask id="scatter-mask" fill="#fff">
        <use xlink:href="#large-scatter-line"/>
      </mask>

      <use fill="url(#scatter-grad)" xlink:href="#large-scatter-line"/>

      <use fill="#58595B" xlink:href="#small-scatter-line" mask="url(#scatter-mask)" opacity=".2"
           style="mix-blend-mode:multiply"/>

    </g>

    <g class="nums-group" :fill="txtColor" :transform="'translate(' + txtTransVal + ' -10)'">
      <text class="scatter-nums" y="135" :style="{ fontSize: points[0].fontSize + 'px' }">

        <tspan class="scatter-num" x="0" :dominant-baseline="!isFF && !isMS ? 'hanging' : 'auto'"
               v-for="(pt, idx) in points"
               :dy="!isFF && !isMS ? (idx * 0.85) + 'em' : isMS ? (idx * 2) + 'em' : (idx * 1.2) + 'em'">

          <tspan class="knockout-30 plus" font-size="0.5291em">+</tspan>
          <tspan class="knockout-50 num" :dominant-baseline="!isFF && !isMS ? 'middle' : 'text-after-edge'" dx="-0.2em"
                 dy="-0em">{{ idx === 0 ? Math.ceil(largeNum) : Math.ceil(smallNum) }}</tspan>
          <tspan class="knockout-30 percent-sign" dx="-0.65em" dy="-0.75em" font-size="0.3291em">%</tspan>

          <tspan class="adobe-clean-black label" font-size="1rem" x="20"
                 :dy="!isSafari && $store.state.device.browser !== 'Chrome for iOS' ? '3em' : '4.2em'">
            {{ pt.title }} -
            <transition mode="out-in">
              <tspan class="industry-tspan" key="mktg" v-if="industry === 'mktg'">MARKETING</tspan>
              <tspan class="industry-tspan" key="it" v-else>IT</tspan>
            </transition>
          </tspan>

        </tspan>

      </text>
    </g>
  </svg>
</template>

<script>
  import StateMixin from '@/components/report/mixins/StateMixin'
  import { dataTransTime } from '@/lib/consts'
  import { gradPtColor } from '@/lib/funcs'
  import { TweenMax, Power2 } from 'gsap'
  import 'gsap/src/uncompressed/plugins/MorphSVGPlugin'

  export default {
    name: 'ScatterVect',
    mixins: [ StateMixin ],
    props: [ 'active', 'indOverride', 'points' ],
    data () {
      return {
        transY: 0,
        transTime: dataTransTime / 2,
        largeNum: 0,
        smallNum: 0,
        viewBox: '0 0 375 458',
        deskViewBox: '0 0 1282 535',
        mktgLargeScatterD: 'M0.366901441,395.476284 L0.366901441,447.955122 C58.5040389,460.946613 127.319426,460.946613 206.813063,447.955122 C286.3067,434.963632 367.580045,434.963632 450.633099,447.955122 L450.633099,0.906030255 C326.547109,0.906030255 303.328261,83.0109402 244.186937,208.651378 C184.566709,336.487646 114.77349,392.687309 0.366901441,395.476284 Z',
        mktgSmallScatterD: 'M2,409.509792 C116.338697,407.06095 188.163777,353.228566 238.03218,304.209585 C340.833992,203.158824 363.73855,160 452,160 L452,479 L2,479 L2,409.509792 Z',
        itLargeScatterD: 'M0.366901441,209.497883 L0.366901441,248.768627 C58.5040389,258.490365 127.319426,258.490365 206.813063,248.768627 C286.3067,239.046889 367.580045,239.046889 450.633099,248.768627 L450.633099,0.547345912 C406.738134,0.547345912 347.750277,9.80047658 246.515408,87.332717 C145.280539,164.864957 114.77349,207.410849 0.366901441,209.497883 Z',
        itSmallScatterD: 'M2,220.009517 C116.338697,218.177367 139.914565,199.163732 238.03218,141.22707 C296.897841,106.46797 363.73855,81.0948182 452,81.0948182 L452,272 L2,272 L2,220.009517 Z',
        largeScatterLineD: 'M0,450 L0.366901441,450 C58.5040389,450 127.319426,450 206.813063,450 C286.3067,450 367.580045,450 450.633099,450 L450.633099,450 C326.547109,450 303.328261,450 244.186937,450 C184.566709,450 114.77349,450 0.366901441,450 Z',
        smallScatterLineD: 'M0,450 C116.338697,450 188.163777,450 238.03218,450 C340.833992,450 363.73855,450 452,450 L452,450 L2,450 L2,450 Z',
        deskMktgLargeScatterD: 'M0,462.124463 L0,523.588181 C165.528327,538.80394 361.459816,538.80394 587.794466,523.588181 C814.129117,508.372423 1045.53096,508.372423 1282,523.588181 L1282,0 C1051.25323,0 864.862089,147.650065 694.205534,243.313343 C523.548978,338.976621 325.738968,458.857989 0,462.124463 Z',
        deskMktgSmallScatterD: 'M0,487.528721 C325.484156,484.657665 529.94622,421.543836 671.904938,364.073307 C964.547431,245.6 1029.74907,195 1281,195 L1281,569 L0,569 L0,487.528721 Z',
        deskItLargeScatterD: 'M0,274.957494 L0,324.754341 C165.011858,337.081886 360.332016,337.081886 585.960474,324.754341 C811.588933,312.426795 1042.26877,312.426795 1278,324.754341 L1278,0 C1153.412,-2.78110868e-14 985.985528,21.7333334 698.648474,120.047262 C411.31142,218.36119 324.722622,272.311053 0,274.957494 Z',
        deskItSmallScatterD: 'M5,287.094523 C329.467812,284.772008 396.370889,260.669468 674.806875,187.226348 C841.854539,143.164149 1031.53362,101 1282,101 L1282,353 L5,353 L5,287.094523 Z',
        deskLargeScatterLineD: 'M0,450 L0,450 C165.011858,450 360.332016,450 585.960474,450 C811.588933,450 1042.26877,450 1278,450 L1278,450 C1153.412,450 985.985528,450 698.648474,450 C411.31142,450 324.722622,450 0,450 Z',
        deskSmallScatterLineD: 'M0,450 C324.467812,450 391.370889,450 669.806875,450 C836.854539,450 1026.53362,450 1277,450 L1277,450 L0,450 L0,450 Z',
        vectH: null
      }
    },
    computed: {
      txtColor () { return gradPtColor( ...this.colors, 0.5 ) },

      txtTransVal () {
        let deskVal = this.winW / 5
        deskVal = deskVal > 300 ? 300 : deskVal
        return this.isSmall ? 20 : deskVal
      }
    },
    watch: {
      active ( val ) {
        if ( val ) this.tweenLines()
      },
      industry () {
        this.tweenLines()
      }
    },
    methods: {
      tweenLines () {
        TweenMax.to( this.$refs.largeLine, this.transTime, {
          morphSVG: {
            shape: this.$refs[ this.industry + 'Large' ],
            shapeIndex: [ 0 ]
          },
          ease: Power2.easeInOut
        } )
        TweenMax.to( this.$refs.smallLine, this.transTime, {
          morphSVG: {
            shape: this.$refs[ this.industry + 'Small' ],
            shapeIndex: [ 0 ]
          },
          ease: Power2.easeInOut
        } )
        TweenMax.to( this, this.transTime, {
          transY: this.industry === 'it' ? 201 : 0,
          largeNum: this.points[ 0 ].val[ this.industry ],
          smallNum: this.points[ 1 ].val[ this.industry ],
          ease: Power2.easeInOut
        } )
      }
    },
    mounted () {
      if ( this.isIE ) {
        setTimeout( () => {
          this.vectH = ((window.innerWidth / 1282) * 535) + 'px'
        }, 250 )
      }
    }
  }
</script>

<style lang="scss">
  @import "../../assets/scss/global/the_goods";

  .scatter-vect {

    @include screen-md-lg-xl {
      position : relative;
      width    : 104%;
      left     : -1%;
    }
  }

  .industry-tspan {
    transition : opacity #{$data-trans-time / 5} ease-in-out;

    &.v-enter, &.v-leave-to {
      opacity : 0
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/svg/ScatterVect.vue